import { useQuery } from 'react-query';

import { Capability, PermissionScope } from '@ge/models/constants';
import { Config, useAuth } from '@ge/shared/data-hooks';

import { fetchTaskSource } from '../services/task-template';
/**
 * Get task sources.
 *
 * @param entityType entity type
 * @param language language
 * @returns {{isLoading: boolean, isError: boolean, data: Object, error: String}}
 */
export const useTaskSource = ({ entityType, page, language } = {}) => {
  const { isAuthorized } = useAuth();
  const isAuthorizedToGetTasks = isAuthorized({
    capabilities: [{ capability: Capability.FIELD_TASKS, scopes: [PermissionScope.VIEW] }],
  });
  return useQuery(
    ['task-sources', { entityType, page, language }],
    () => fetchTaskSource({ assetType: entityType, page, language }),
    { enabled: isAuthorizedToGetTasks, ...Config.EXECUTE_ONCE },
  );
};
